module.exports = "<oligo-summary-bar class=\"oligo-summary-bar__floating\"\n                   ng-if=\"oligoSummaryManager.floatingBarVisible\"\n                   cart-processing=\"oligoSummaryManager.cartProcessing\"\n                   on-cart-state-change=\"oligoSummaryManager.onCartStateChange({state})\">\n</oligo-summary-bar>";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/components/oligo-summary-bar-manager/oligo-summary-bar-manager.tpl.html
// module id = pDM8
// module chunks = 1